import * as Clipboard from 'expo-clipboard'

export async function copyToClipboard(value: string): Promise<boolean> {
  if (!value) return false
  try {
    await Clipboard.setStringAsync(value)
    return true
  } catch {
    return false
  }
}
